export default {
  description: {
    id: 'product_meta_description',
    defaultMessage:
      '{category} {brand} {title} ✌ Up to 70% off compared to new ✅ Free delivery ✅ Cheap {model} ✅ {warrantyDuration} year warranty ✅ {coolingOffDays}-day money-back guarantee',
  },
}
